export class Trailer {
  constructor() {}

  trailerId: string;
  name: string;
  picture: string;
  description: string;
  releaseDate: string;
  videoUrl: string;
}



// WEBPACK FOOTER //
// ./src/data/Trailer.ts